export default __webpack_public_path__ + "static/media/about-second.55138541.jpg";